exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-51da9c44] .el-table .el-table__body-wrapper .el-table__body .el-table__row,[data-v-51da9c44] .el-table .el-table__body-wrapper .el-table__body .el-table__row .el-table__cell{background-color:transparent!important}", ""]);

// exports
